import { createEnumHelper } from '@seiue/util'
import { CourseOutlineTaskTypeEnum } from 'packages/sdks-next/growp'

export const courseOutlineTaskTypeEnumToLabel = createEnumHelper(() => ({
  [CourseOutlineTaskTypeEnum.Video]: '视频',
  [CourseOutlineTaskTypeEnum.Pdf]: 'PDF',
  [CourseOutlineTaskTypeEnum.Exercise]: '习题',
}))
